module.exports = __webpack_public_path__ + "img/UserQualifications.dba1ad9a.svg";